import { useLocalizedHref } from "@/libraries/web-framework/index.ts";

import {
    Button,
    ButtonColorAgainst,
    ButtonSize,
    ButtonVariant
} from "../../../../libraries/design/components/button/src/button.tsx";

export type UniformButtonProps = {
    text: string;
    href: string;
    size?: ButtonSize;
    variant?: ButtonVariant;
    colorAgainst?: ButtonColorAgainst;
};

const UniformButton = (props: UniformButtonProps) => {
    const localizedHref = useLocalizedHref(props.href);
    return (
        <Button {...props} href={localizedHref}>
            {props.text}
        </Button>
    );
};

export default UniformButton;
